import { SxProps, Theme } from "@mui/material";
import { grey } from "@mui/material/colors";
import { LIGHT_GREEN, LIGHT_GREY } from "styles/oneOffColor";

const styles = {
  header: { flexWrap: "wrap", rowGap: 1 } satisfies SxProps<Theme>,
  title: { fontWeight: 700 } satisfies SxProps<Theme>,
  expiresChip: {
    backgroundColor: LIGHT_GREEN,
    color: "green.main",
    fontWeight: 600,
  } satisfies SxProps<Theme>,
  description: { mt: 1.5 } satisfies SxProps<Theme>,
  balanceCard: {
    mt: 2.5,
    p: 2,
    borderRadius: 2,
    backgroundColor: LIGHT_GREY,
  } satisfies SxProps<Theme>,
  balanceLeft: { minWidth: 0 } satisfies SxProps<Theme>,
  balanceLabel: { fontWeight: 700 } satisfies SxProps<Theme>,
  balanceRight: { textAlign: "right", flexShrink: 0 } satisfies SxProps<Theme>,
  balanceValue: {
    fontWeight: 700,
    fontSize: "1.1rem",
    lineHeight: 1.2,
  } satisfies SxProps<Theme>,
  balanceUnit: { whiteSpace: "nowrap" } satisfies SxProps<Theme>,
  options: { mt: 2.5 } satisfies SxProps<Theme>,
  option: (isSelected: boolean): SxProps<Theme> => ({
    p: 1.75,
    borderRadius: 2,
    cursor: "pointer",
    border: "2px solid",
    borderColor: isSelected ? "green.main" : grey[200],
    transition: "border-color 0.15s",
  }),
  radio: (isSelected: boolean): SxProps<Theme> => ({
    flexShrink: 0,
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "2px solid",
    borderColor: isSelected ? "green.main" : grey[400],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  radioDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: "green.main",
  } satisfies SxProps<Theme>,
  optionMain: { flexGrow: 1, minWidth: 0 } satisfies SxProps<Theme>,
  optionCredits: { fontWeight: 700, lineHeight: 1.2 } satisfies SxProps<Theme>,
  optionCreditsUnit: {
    color: "text.secondary",
    fontWeight: 400,
  } satisfies SxProps<Theme>,
  optionRight: {
    minWidth: 0,
    flexWrap: "wrap",
    columnGap: 1,
    rowGap: 0.5,
  } satisfies SxProps<Theme>,
  badge: (popular: boolean): SxProps<Theme> => ({
    height: 18,
    backgroundColor: popular ? "purple.light" : LIGHT_GREEN,
    color: popular ? "purple.dark" : "green.main",
    fontWeight: 700,
    fontSize: "0.6rem",
    "& .MuiChip-label": { px: 1 },
  }),
  price: {
    flexShrink: 0,
    fontWeight: 700,
    fontSize: "1rem",
  } satisfies SxProps<Theme>,
  button: { mt: 2.5 } satisfies SxProps<Theme>,
  disclaimer: {
    mt: 1.5,
    fontStyle: "italic",
    textAlign: "center",
  } satisfies SxProps<Theme>,
};

export default styles;
